// Dashboard Users profile & geography page translations (pt-BR), loaded into dashboard.users.profile by ../pt-BR.users.js
module.exports = {
  menu: "Perfil & Geografia",
  title: "Perfil & Geografia",
  description: "Género, faixa etária e origem dos utilizadores ativos no período.",
  kpis: {
    avgAge: "Idade média",
    genderInformed: "Género informado",
    birthInformed: "Data de nascimento informada",
    topAge: "Faixa com mais utilizadores",
    countries: "Países",
    regions: "Estados e regiões",
    cities: "Cidades",
    topCountry: "País com mais utilizadores",
  },
  info: {
    avgAge: "Idade média dos utilizadores ativos no período que informaram a data de nascimento.\nFonte: Firebase (perfis dos utilizadores ativos no período).",
    genderInformed: "Utilizadores ativos no período que informaram o género.\nFonte: Firebase (perfis dos utilizadores ativos no período).",
    birthInformed: "Utilizadores ativos no período que informaram a data de nascimento.\nFonte: Firebase (perfis dos utilizadores ativos no período).",
    topAge: "Faixa etária com mais utilizadores ativos no período.\nFonte: Firebase (perfis dos utilizadores ativos no período).",
    countries: "Países da morada dos utilizadores ativos no período.\nFonte: Firebase (perfis dos utilizadores ativos no período).",
    regions: "Estados e regiões da morada dos utilizadores ativos no período.\nFonte: Firebase (perfis dos utilizadores ativos no período).",
    cities: "Cidades da morada dos utilizadores ativos no período.\nFonte: Firebase (perfis dos utilizadores ativos no período).",
    topCountry: "País com mais utilizadores ativos no período.\nFonte: Firebase (perfis dos utilizadores ativos no período).",
  },
  hints: {
    ofBase: "{value} da base",
    withUsers: "com utilizadores ativos",
  },
  years: "{value} anos",
  age: {
    1317: "13–17",
    1824: "18–24",
    2534: "25–34",
    3544: "35–44",
    4554: "45–54",
    5564: "55–64",
    6500: "65+",
  },
  continents: {
    europe: "Europa",
    southAmerica: "América do Sul",
    northAmerica: "América do Norte",
    africa: "África",
    asia: "Ásia",
    oceania: "Oceânia",
  },
  panels: {
    gender: "Género",
    users: "utilizadores",
    age: "Faixa etária",
    ageNote: "Menores de 18 anos aparecem só em dados agregados, conforme o RGPD.",
    map: "Mapa — utilizadores por cidade",
    continents: "Continentes",
    countriesSub: "países",
    topCountries: "Top 10 países",
    topCities: "Top 10 cidades",
  },
  panelInfo: {
    gender: "Utilizadores ativos no período por género.\nFonte: Firebase (perfis dos utilizadores ativos no período).",
    age: "Utilizadores ativos no período por faixa etária.\nFonte: Firebase (perfis dos utilizadores ativos no período).",
    map: "Utilizadores ativos no período por cidade da morada.\nFonte: Firebase (perfis dos utilizadores ativos no período).",
    continents: "Utilizadores ativos no período por continente da morada.\nFonte: Firebase (perfis dos utilizadores ativos no período).",
    topCountries: "Países com mais utilizadores ativos no período.\nFonte: Firebase (perfis dos utilizadores ativos no período).",
    topCities: "Cidades com mais utilizadores ativos no período.\nFonte: Firebase (perfis dos utilizadores ativos no período).",
  },
};
